module.exports = __webpack_public_path__ + "static/media/6-5.657d2302.mp3";